import { gqlClient } from '@/api/graphql-client';
import applianceKeys from '@/api/queries/appliances/keyFactory';
import { graphql } from '@/gql';
import { useQuery } from '@tanstack/react-query';

const GetAppliancesQuery = graphql(`
  query GetAppliances($pagination: PaginationInput) {
    appliances(pagination: $pagination) {
      items {
        id
        isPreferred
        totalPrice {
          value
          currency {
            code
            exponent
          }
        }
        productSpec {
          id
          name
          category
          manufacturer
          modelNumber
          image {
            id
            url
          }
          nominalOutputKw
          domesticHotWaterLitres
          scopAtDefaultFlow
          panelCapacityW
          acOutputKw
          hybrid
          usableCapacityKwh
          archivedAt
          dimensions {
            heightMm
            widthMm
            depthMm
          }
        }
        items {
          id
          name
          description
          price {
            unitPrice {
              value
              currency {
                code
                exponent
              }
            }
          }
        }
      }
      totalCount
    }
  }
`);

const useGetAppliances = () => {
  const { data, ...rest } = useQuery({
    queryKey: applianceKeys.appliances(),
    queryFn: () =>
      gqlClient.request(GetAppliancesQuery, {
        // The management list shows every live Appliance; 100 is the server's
        // maximum page size and comfortably exceeds any account's catalogue.
        pagination: { limit: 100, offset: 0 },
      }),
    meta: { errorMessage: 'Failed to load Appliances' },
  });

  return {
    appliances: data?.appliances?.items,
    totalCount: data?.appliances?.totalCount,
    ...rest,
  };
};

export default useGetAppliances;
